<template lang="pug">
div(style="margin-top: -24px;margin-left: -15px;margin-right: -15px;")
  #Categoria
    v-layout(align-start='', justify-start='', row='', fill-height='')
      v-flex(xs12, md12, sm12)
        v-card(color='', style="border-radius:5px;background-color: white;")
            v-card-title(style='padding: 8px !important;').justify-center
              img(src='../assets/logo.png', style='height: auto;width: 160px;border-radius:5px;padding:5px;')
        v-card(color='', style="border-radius:5px;background-color: black")
            v-card-title(style="padding: 7px;").justify-center
                span.white--text  Administración de Marcas
    v-flex(xs12)
      template
        v-tabs(v-model='active', color="#ef8025", centered, dark)
          v-tab(:key='0', ripple='') Marcas Milo
          v-tab(:key='1', ripple='') Marcas Grupo
          v-tab-item(:key='0')
            v-card(flat='')
              v-flex(xs12)
                div(style="margin-top:20px")
                  v-flex(xs12)
                    v-layout(wrap)
                      v-flex(xs12)
                        v-text-field(v-model='search', append-icon='search', label='Buscar' style='width:100%;')
                v-layout(align-start='', justify-start='', row='', fill-height='')
                  v-flex(xs12 style='margin-top: 5px;')
                    v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                        v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                            span.white--text Lista de Marcas
                    v-data-table.elevation-1(:headers='headers', :items="marcas", :search='search', style="margin-top: 5px;")
                      template(slot='items', slot-scope='props')
                        td {{ props.item.co_lin }}
                        td {{ props.item.lin_des }}
          v-tab-item(:key='1')
            v-card(flat='')
              v-flex(xs12)
                div(style="margin-top:20px")
                  v-flex(xs12)
                    v-layout(wrap)
                      v-flex(xs12)
                        v-text-field(v-model='search2', append-icon='search', label='Buscar' style='width:100%;')
                v-layout(align-start='', justify-start='', row='', fill-height='')
                  v-flex(xs12 style='margin-top: 5px;')
                    v-card(color='', style="border-radius: 0px 0px 20px 20px;background-color:black;")
                        v-card-title(style="padding: 7px;margin-top: 0px;").justify-center
                            span.white--text Lista de Marcas
                    v-data-table.elevation-1(:headers='headers', :items="marcasG", :search='search2', style="margin-top: 5px;")
                      template(slot='items', slot-scope='props')
                        td {{ props.item.co_lin }}
                        td {{ props.item.lin_des }}
</template>

<script>
import Api from "@/services/methods";
import { serverImg } from "@/services/environment";
export default {
  name: "mMarcas",
  components: {},
  data: () => ({
    search: "",
    search2: "",
    active: null,
    marcas: [],
    marcasG: [],
    ruta: serverImg,
    headers: [
      { text: "Codigo", value: "co_lin" },
      { text: "Nombre", value: "lin_des" },
    ],
    cre: "",
    mod: "",
    elm: ""
  }),
  created() {
    this.verificacion();
    this.initialize();
  },
  methods: {
    verificacion() {
      for (let i = 0; i < this.$store.state.adminmilo.permisos.length; i++) {
        if (this.$store.state.adminmilo.permisos[i].ruta === "Marcas") {
          for (
            let j = 0;
            j < this.$store.state.adminmilo.permisos[i].accion.length;
            j++
          ) {
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Crear"
            ) {
              this.cre = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] ===
              "Modificar"
            ) {
              this.mod = "yes";
            }
            if (
              this.$store.state.adminmilo.permisos[i].accion[j] === "Eliminar"
            ) {
              this.elm = "yes";
            }
          }
        }
      }
    },
    initialize() {
      Api.get("marcas").then(res => {
        this.marcas = res.data;
      });
      Api.get2("marcas").then(res => {
        this.marcasG = res.data;
      });
    },
    close() {
      this.initialize();
    }
  }
};
</script>
<style lang="scss">
@import "~@/assets/scss/categoria.scss";
</style>
